export const SENTRY_ERRORS = {
  ANIMATION: 'Animation Error',
  LOAD_PRODUCT_VARIANT: 'loadProductVariant Error',
  REQUEST_DEMO: 'request demo error',
  DEMO_FORM: 'Error while submitting demo form',
  BACK_IN_STOCK_ERROR: 'back in stock error',
};

export const QUIZ_EVENT_CATEGORY = {
  MAIN: 'SH Quiz - Main',
  DETAILS: 'SH Quiz - Details',
  COMBINATIONS: 'SH Quiz - Combinations',
  INTERACTION: 'SH Quiz - Product Interactions',
};

export const ACTIONS = {
  ADD: 'Adding Product',
  REMOVE: 'Removing Product',
};

export const WEBINARS_DATA_KEY = 'type';

export const WEBINAR_TYPES = {
  BUILDERS: 'Builders',
  MULTIFAMILY: 'Multifamily',
  PRO_INSTALLERS: 'Pro-Installers',
};

export const QUIZ_STEPS = {
  STEP_0_IMPRESSION: 'Step 0: Impression',
  STEP_1_HOME_SIZE: 'Step 1: Home Size',
  STEP_2_PRODUCTS: 'Step 2: Products',
  STEP_3_INTERCOM: 'Step 3: Intercom',
  STEP_4_COMPLETED: 'Step 4: Quiz completed',
};

export const WEBINAR_EVENT_CATEGORY = {
  RECORD: 'Webinars - Recorded Events',
  LIVE: 'Webinars - Live Events',
};

export const WEBINAR_ACTIONS = {
  SHOW_DESC: 'Step 0: Webinar Description',
  START_REGISTRATION: 'Step 1: Start Registration',
  END_REGISTRATION: 'Step 2: Complete Registration',
  START_WATCHING: 'Step 3: Start Watching',
  ADD_TO_CALENDAR: 'Step 3: Add to Calendar',
};

export const PRODUCTS = {
  productTagsAndTypes: {
    'one-switch': 'One switch home control',
    'two-switch': 'Two switch home control',
    'three-switch': 'Three switch home control',
    'four-switch': 'Four switch home control',
    Switch: 'Smart Dimmer Switch',
    Plug: 'Smart Plug',
  },
};

export const OPEN_MOBILE_CHILD_LINKS_NAV_ATTR =
  'data-open-mobile-child-links-nav';

// eslint-disable-next-line no-useless-escape
export const REGEXP_SPECIAL_SYMBOLS = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;

export const PRODUCT_TYPE = {
  BUNDLE: 'Bundle',
  CONTROLS: 'Controls',
  FRAMES: 'Frames',
  REFURBISHED_CONTROLS: 'Controls Refurbished',
};

export const NOT_AVAILABLE_TEXT = 'OUT OFF STOCK';
export const PRE_ORDER_TEXT = 'PRE-ORDER NOW';
export const ADD_TO_CART_TEXT = 'ADD TO CART';
